import { LessonDefinition } from "../../types";

const lesson: LessonDefinition = {
  id: "narrative-vs-interaction-audio",
  courseId: "reports-from-audio",
  order: 1,
  title: "Audio types",
  subtitle: "Narrative vs interaction",
  summary:
    "A recording is either you dictating or a conversation, and each goes through a different transcription engine. Setting the type correctly matters more than any other upload choice.",
  learn: [
    "Decide whether a recording is a narrative or an interaction",
    "Add speaker roles and spoken languages to an interaction file",
    "Know what each type produces in the draft",
  ],
  sceneId: "narrative-vs-interaction-audio",
  tourId: "narrative-vs-interaction-audio",
  minutes: 3,
  releasedAt: "2025-06-01T00:00:00.000Z",
  body: [
    {
      type: "paragraph",
      text: "A **Narrative** is you alone, dictating the report. An **Interaction** is a recording of a conversation: an interview, a traffic stop, body-cam audio. They go through different transcription engines, and the AI treats them differently when it writes.",
    },
    {
      type: "bullets",
      items: [
        "Narrative: one voice, transcribed as a block of text. The AI writes the report from what you said, in your perspective.",
        "Interaction: multiple voices, transcribed with speaker separation and timestamps. The AI writes what happened and quotes or paraphrases the speakers. You can name the speakers afterward in the Transcription tab.",
      ],
    },
    {
      type: "steps",
      items: [
        "Click **New Case**.",
        "Click **Upload Files** and add a recording.",
        "On the file row, click **Narrative** or **Interaction**.",
        "For an interaction, open **Speaker Information** and click **Add Speaker** for each person.",
        "Pick a role for each speaker (Officer, Detective, Investigator, Victim, Suspect, Witness, Complainant, Other) and a name if you have one.",
        "If the conversation was not entirely in English, open **Spoken Languages** and click **Add Language** for each language used.",
        "Add anything the recording does not say in **Additional Context (optional)**.",
        "Click **Upload (1 file)**.",
      ],
    },
    {
      type: "callout",
      tone: "note",
      title: "Defaults to check",
      text: "Files over 75 MB and any video default to **Interaction**, because long files and body-cam footage are almost always conversations. A short voice memo defaults to **Narrative**. Check the row before you upload.",
    },
    {
      type: "paragraph",
      text: "Speaker names you give up front end up in the draft. Names added later in the Transcription tab update the transcript, and the narrative picks them up when you regenerate.",
    },
    {
      type: "paragraph",
      text: "Next, \"Combine recordings\" shows how to put both types in one case.",
    },
  ],
  related: ["combine-narrative-and-interaction", "transcription-and-speakers", "first-narrative-report"],
};

export default lesson;
